import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke", "size"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ApplyMoreFiltersIcon = /*#__PURE__*/memo(function (_ref) {
  var stroke = _ref.stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 18 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 18",
    children: /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M6.121 1.879A3 3 0 111.88 6.12 3 3 0 016.12 1.88zM18 4H7M18.121 11.879a3 3 0 11-4.242 4.242 3 3 0 014.242-4.242zM2 14h11"
    })
  });
});